import { render, staticRenderFns } from "./pianoCompanyManage.vue?vue&type=template&id=9b3d9a0a&scoped=true&"
import script from "./pianoCompanyManage.vue?vue&type=script&lang=js&"
export * from "./pianoCompanyManage.vue?vue&type=script&lang=js&"
import style0 from "./pianoCompanyManage.vue?vue&type=style&index=0&id=9b3d9a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3d9a0a",
  null
  
)

export default component.exports